import { render, staticRenderFns } from "./ExpensesList.vue?vue&type=template&id=1080cc0e&scoped=true"
import script from "./ExpensesList.vue?vue&type=script&lang=js"
export * from "./ExpensesList.vue?vue&type=script&lang=js"
import style0 from "./ExpensesList.vue?vue&type=style&index=0&id=1080cc0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1080cc0e",
  null
  
)

export default component.exports